import { createAction } from "@reduxjs/toolkit";

export const apiCallBegan2 = createAction<any | undefined>("api2/callBegan2");

export const apiCallSuccess2 = createAction<any | undefined>("api2/callSuccess2");
export const apiCallFailed2 = createAction<any | undefined>("api2/callFailed2");
export const apiNonCallChange2 = createAction<any | undefined>("api2/NonCallChange2");